function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#test-email_svg__clip-test-email)",
  stroke: "#333",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.5 21.5v0a.293.293 0 01.5.207V42a1 1 0 01-1 1H7a1 1 0 01-1-1V21.707c0-.26.315-.392.5-.207v0M7 22l13 9m21-9l-13 9M6 21.5l4-3m32 3l-4-3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 23.5v-18a.5.5 0 01.5-.5h27a.5.5 0 01.5.5v18M41.5 42.5L24.638 28.529a1 1 0 00-1.276 0L6.5 42.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 16.5,
  r: 6.875
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.786 16.857l2.5 2.857L27 14",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "test-email_svg__clip-test-email"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})));

function SvgTestEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtdGVzdC1lbWFpbCkiPgo8cGF0aCBkPSJNNDEuNSAyMS41VjIxLjVDNDEuNjg0NSAyMS4zMTU1IDQyIDIxLjQ0NjIgNDIgMjEuNzA3MUw0MiA0MkM0MiA0Mi41NTIzIDQxLjU1MjMgNDMgNDEgNDNMNyA0M0M2LjQ0NzcyIDQzIDYgNDIuNTUyMyA2IDQyTDYgMjEuNzA3MUM2IDIxLjQ0NjIgNi4zMTU0OSAyMS4zMTU1IDYuNSAyMS41VjIxLjUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcgMjJMMjAgMzFNNDEgMjJMMjggMzEiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYgMjEuNUwxMCAxOC41TTQyIDIxLjVMMzggMTguNSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAgMjMuNVY1LjVDMTAgNS4yMjM4NiAxMC4yMjM5IDUgMTAuNSA1SDM3LjVDMzcuNzc2MSA1IDM4IDUuMjIzODYgMzggNS41VjIzLjUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQxLjUgNDIuNUwyNC42Mzc5IDI4LjUyODZDMjQuMjY3OCAyOC4yMjIgMjMuNzMxOSAyOC4yMjIgMjMuMzYxOSAyOC41Mjg2TDYuNSA0Mi41IiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxjaXJjbGUgY3g9IjI0IiBjeT0iMTYuNSIgcj0iNi44NzUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxwYXRoIGQ9Ik0yMC43ODU2IDE2Ljg1NzFMMjMuMjg1NiAxOS43MTQzTDI3IDE0IiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcC10ZXN0LWVtYWlsIj4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgTestEmail as ReactComponent };